import { render, staticRenderFns } from "./massSend.vue?vue&type=template&id=483b641e"
import script from "./massSend.vue?vue&type=script&lang=js"
export * from "./massSend.vue?vue&type=script&lang=js"
import style0 from "./massSend.vue?vue&type=style&index=0&id=483b641e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports